"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _serviceUrl = _interopRequireDefault(require("./service-url.json"));

var _v = _interopRequireDefault(require("uuid/v1"));

var Upload = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Upload, _React$Component);

  function Upload(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Upload);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Upload).call(this, props));

    _this.validateProps();

    _this.state = (0, _objectSpread2["default"])({
      label: props.label || "Choose a file...",
      hasValidDimensions: true,
      uuid: (0, _v["default"])(),
      reader: new FileReader(),
      file: null,
      showRetryButton: false
    }, _this.props.extensions && {
      extensions: _this.props.extensions.map(function (extension) {
        return extension.toLowerCase();
      })
    });
    _this.validateProps = _this.validateProps.bind((0, _assertThisInitialized2["default"])(_this));
    _this.fileOnChange = _this.fileOnChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.retryUpload = _this.retryUpload.bind((0, _assertThisInitialized2["default"])(_this));
    _this.validateImage = _this.validateImage.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Upload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.reader.addEventListener("load", this.validateImage, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.reader.removeEventListener("load", this.validateImage, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _prevState) {
      if (this.props.label !== prevProps.label) {
        //reset UI
        this.setState({
          label: this.props.label,
          showRetryButton: false
        });
      }
    }
  }, {
    key: "validateProps",
    value: function validateProps() {
      if (typeof this.props.onUploadSuccess !== "function") {
        throw new Error("property onUploadSuccess is required and must be a function");
      }

      if (typeof this.props.onUploadFail !== "function") {
        throw new Error("property onUploadFail is required and must be a function");
      }

      if (this.props.extensions && !Array.isArray(this.props.extensions)) {
        throw new Error("property extensions must be an array!");
      }

      if (this.props.height && typeof this.props.height !== "number") {
        throw new Error("property height must be a number");
      }

      if (this.props.width && typeof this.props.width !== "number") {
        throw new Error("property width must be a number");
      }

      if (this.props.maxHeight && typeof this.props.maxHeight !== "number") {
        throw new Error("property maxHeight must be a number");
      }

      if (this.props.maxWidth && typeof this.props.maxWidth !== "number") {
        throw new Error("property maxWidth must be a number");
      }

      if (this.props.minWidth && typeof this.props.minWidth !== "number") {
        throw new Error("property minWidth must be a number");
      }

      if (this.props.minHeight && typeof this.props.minHeight !== "number") {
        throw new Error("property minHeight must be a number");
      }
    }
  }, {
    key: "validateImage",
    value: function validateImage() {
      var _this2 = this;

      var image = new Image();

      image.onload = function () {
        _this2.setState({
          hasValidDimensions: _this2.hasValidImageDimensions(image)
        });

        _this2.uploadFile(_this2.state.file);
      };

      image.src = this.state.reader.result;
    }
  }, {
    key: "fileOnChange",
    value: function fileOnChange(event) {
      if (event.target.files && event.target.files.length > 0) {
        var file = event.target.files[0];
        this.setState({
          label: this.fileFromPath(file.name),
          file: file
        });

        if (this.isImageToValidate(file)) {
          this.state.reader.readAsDataURL(file); //triggers reader.load that will validate selected image
        } else {
          this.uploadFile(file);
        }
      }
    }
  }, {
    key: "isImageToValidate",
    value: function isImageToValidate(file) {
      return (this.props.height || this.props.width || this.props.maxWidth || this.props.maxHeight || this.props.minWidth || this.props.minHeight) && file && file.type.startsWith('image/');
    }
  }, {
    key: "hasValidExtension",
    value: function hasValidExtension(filename) {
      if (this.state.extensions && !this.state.extensions.includes(filename.substring(filename.lastIndexOf('.')).toLowerCase())) {
        this.props.onUploadFail("This type of extension is not accepted. Accepted extensions : " + this.state.extensions);
        return false;
      }

      return true;
    }
  }, {
    key: "hasValidImageDimensions",
    value: function hasValidImageDimensions(image) {
      var dimensionsMessage = [];
      this.props.width && this.props.width !== image.width && dimensionsMessage.push("width of ".concat(this.props.width, " pixels "));
      this.props.height && this.props.height !== image.height && dimensionsMessage.push("height of ".concat(this.props.height, " pixels "));
      this.props.maxWidth && this.props.maxWidth < image.width && dimensionsMessage.push("max width of ".concat(this.props.maxWidth, " pixels "));
      this.props.maxHeight && this.props.maxHeight < image.height && dimensionsMessage.push("max height of ".concat(this.props.maxHeight, " pixels "));
      this.props.minWidth && this.props.minWidth > image.width && dimensionsMessage.push("minimum width of ".concat(this.props.minWidth, " pixels "));
      this.props.minHeight && this.props.minHeight > image.height && dimensionsMessage.push("minimum height of ".concat(this.props.minHeight, " pixels "));

      if (dimensionsMessage.length) {
        this.props.onUploadFail("The image must have " + dimensionsMessage.join("and "));
        return false;
      }

      return true;
    }
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file) {
        var req, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  loading: true
                });

                if (!(this.hasValidExtension(file.name) && this.state.hasValidDimensions)) {
                  _context.next = 24;
                  break;
                }

                this.setState({
                  showRetryButton: false
                });
                _context.prev = 3;
                _context.next = 6;
                return fetch((this.props.serviceUrl || _serviceUrl["default"].prod) + this.state.uuid, {
                  method: "PUT",
                  headers: {
                    'Authorization': "Bearer ".concat(this.props.accessToken),
                    // expect authentication by KeyCloak with Bearer
                    "Content-Type": "application/octet-stream"
                  },
                  body: file
                });

              case 6:
                req = _context.sent;

                if (!req.ok) {
                  _context.next = 16;
                  break;
                }

                _context.next = 10;
                return req.json();

              case 10:
                result = _context.sent;

                if (result.location) {
                  _context.next = 13;
                  break;
                }

                throw new Error("Result must include saved file location!");

              case 13:
                this.props.onUploadSuccess(result.location);
                _context.next = 18;
                break;

              case 16:
                this.setState({
                  showRetryButton: true
                });
                this.props.onUploadFail(req.statusText);

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](3);
                this.setState({
                  showRetryButton: true
                });
                this.props.onUploadFail(_context.t0.message);

              case 24:
                this.setState({
                  loading: false
                });

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 20]]);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "retryUpload",
    value: function retryUpload() {
      this.fileOnChange({
        target: {
          files: [this.state.file]
        }
      });
    }
  }, {
    key: "fileFromPath",
    value: function fileFromPath(path) {
      return path.replace(/^.*[\\/]/, "");
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "asset-uploader"
      }, _react["default"].createElement("input", {
        type: "file",
        accept: this.state.extensions,
        id: this.state.uuid,
        className: "au_fileinput",
        onChange: this.fileOnChange
      }), _react["default"].createElement("label", {
        htmlFor: this.state.uuid,
        className: "au_label"
      }, _react["default"].createElement("span", {
        className: "au_hint"
      }, this.state.label), _react["default"].createElement(AttachFileIcon, null)), this.state.loading && _react["default"].createElement("span", {
        className: "au_loading"
      }, "Loading..."), this.state.showRetryButton && _react["default"].createElement("button", {
        className: "au_retry",
        onClick: this.retryUpload
      }, "Retry"));
    }
  }]);
  return Upload;
}(_react["default"].Component);

function AttachFileIcon() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, _react["default"].createElement("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
  }), _react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

var _default = Upload;
exports["default"] = _default;